
        document.addEventListener('DOMContentLoaded', function () 
        {
            // const productCards = document.querySelectorAll('.product-card, .product-card1, .product-card2, .product-card3, .product-card4, .product-card5');
            // productCards.forEach(card =>
            //      {
            //     card.addEventListener('click', function () {
            //         window.location.href = 'product-details.html';
            //     });
            // });

            // Hamburger and sidebar logic
            const hamburgerBtn = document.getElementById("hamburgerBtn");
            const sidebarMenu = document.getElementById("sidebarMenu");
            const closeSidebar = document.getElementById("closeSidebar");

            if (hamburgerBtn && sidebarMenu && closeSidebar) {
                hamburgerBtn.addEventListener("click", function () {
                    sidebarMenu.classList.add("open");
                });
                closeSidebar.addEventListener("click", function () {
                    sidebarMenu.classList.remove("open");
                });
                // Optional: close sidebar when clicking outside
                document.addEventListener("click", function (e) {
                    if (
                        sidebarMenu.classList.contains("open") &&
                        !sidebarMenu.contains(e.target) &&
                        e.target !== hamburgerBtn &&
                        e.target.parentNode !== hamburgerBtn
                    ) {
                        sidebarMenu.classList.remove("open");
                    }
                });
            }
        });
    